import { Component, ViewEncapsulation, Input } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { InvoiceService } from '@app/cp/shared/services/invoice.service';
import { BaseAppEditComponent } from '@app/cp/shared/base-components/base-app-edit.component';
import { InvoiceBus } from '@app/cp/shared/models/InvoiceBus';
import { SaveMode } from '../../shared/enums/SaveMode';
import { CommonParam } from '../../shared/models/CommonParam';
import { CommonFunctions } from '../../shared/static/common-functions';
import { InvoiceMessageInfo } from '../../shared/models/InvoiceMessageInfo';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'invoice-cm-cr',
    templateUrl: './invoice-cm-cr.component.html',
    styleUrls: ['./invoice-cm-cr.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InvoiceCMCRComponent extends BaseAppEditComponent<InvoiceBus, InvoiceService>  {
    compLoader: ICPLoader = this as any;
    constructor(globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, svc_data: InvoiceService) {
        super(globals, qry_rd);
        this.appCode = "InvoiceCMCR";
        this.svc_data = svc_data;
        this.saveMode = SaveMode.individual;
        this.readOnly = false;
        //    this.createForm();

    }
    @Input() data: InvoiceBus;

    protected _active: boolean = false;
    @Input() set active(value: boolean) {
        this.beforeActiveSet(value);
        this._active = value;
    }
    get active(): boolean {
        return this._active;
    }
    beforeActiveSet(value: boolean) {
        if (value) {
            this.clear();
            this.readOnly = false;
        }
    }
    clear() {
        this.labor = 0;
        this.material = 0;
        this.other = 0;
        this.total = 0;
        this.isTaxable = false;
    }
    saving: boolean = false;
    labor: number = 0;
    material: number = 0;
    other: number = 0;
    total: number = 0;
    isTaxable: boolean = false;

    calculateTotal() {
        this.total = this.labor + this.material + this.other;
    }
    onBlur(e: any) {
        this.calculateTotal();
    }
    cancel() {
        this.close(null, false);
    }
    saveIndividual() {
        let id = CommonFunctions.hasValue(this.data) && CommonFunctions.hasGuidValue(this.data.invoiceId) ? this.data.invoiceId : null;
        if (id) {

            this.compLoader.cpLoaderOn();
            this.saving = true;
            let param: CommonParam = new CommonParam();
            param.addParam("InvoiceId", id);
            param.addParam("IsTaxable", this.isTaxable);
            param.addParam("LAB", this.labor);
            param.addParam("MAT", this.material);
            param.addParam("OTH", this.other);
            param.addParam("Total", this.total);
            CommonFunctions.unsubscribe(this.subs_save);
            this.subs_save = this.svc_data.createCreditMemoCR(param).subscribe((info: InvoiceMessageInfo) => {
                if (!info.saveError) {
                    this.saveSuccess("Credit Memo Successfully Created")
                    this.close(true, false);
                }
                else {
                    this.saveError(info.message);
                }
                this.compLoader.cpLoaderOff();
                this.saving = false;
                console.log("cm-cr: ", info);
            });
        }
    }

    setup() {
    }
}

